<template>
  <div>
    <Fontnavbar title="订单详情"/>
    <div class="pan">
      <van-row type="flex" justify="space-around" class="label_tar">
        <van-col span="12">订单号: {{ order.order_no }}</van-col>
        <van-col span="8">订单总金额: {{ order.order_money }}</van-col>
      </van-row>
      <van-row type="flex" justify="space-around" class="label_tar">
        <van-col span="12">退款单号: {{ order.refund_no }}</van-col>
        <van-col span="8">退款金额: {{ order.refund_money }}</van-col>
      </van-row>
      <van-row type="flex" justify="space-around" class="label_tar">
        <van-col span="8">类型: {{ order.after_type_text }}</van-col>
        <van-col span="12">状态: {{ order.after_status_text }}</van-col>
      </van-row>
      <van-row type="flex" justify="space-around" class="label_tar" v-if="order.logistic_no">
        <van-col span="8">物流公司: {{ order.logistic_name }}</van-col>
        <van-col span="12">物流单号: {{ order.logistic_no }}</van-col>
      </van-row>
      <van-row type="flex" justify="space-around" class="label_tar">
        <van-col span="22">申请时间: {{ order.create_time_text }}</van-col>
      </van-row>
      <van-row type="flex" justify="space-around" align="center" class="label_tar">
        <van-col span="4">图片说明: </van-col>
        <van-col span="16">
          <van-image
              class="order_images"
              width="60px"
              height="60px"
              fit="cover"
              :src="imgDomain + val"
              v-for="(val,index) in order.images_arr"
              :key="index"
              @click="browsePictures(index)"
          />
        </van-col>
      </van-row>
      <van-row type="flex" justify="space-around" align="center" class="label_tar">
        <van-col span="4">退款原因: </van-col>
        <van-col span="16">{{ order.refund_reason }}</van-col>
      </van-row>
      <van-row type="flex" justify="space-around" align="center" class="label_tar">
        <van-col span="6">商家退货信息: </van-col>
        <van-col span="14">{{ order.return_info }}</van-col>
      </van-row>
      <van-row type="flex" justify="space-around" align="center" class="label_tar">
        <van-col span="4">商家备注: </van-col>
        <van-col span="16">{{ order.remark }}</van-col>
      </van-row>

      <van-steps direction="vertical" :active="active">
        <van-step v-for="(item, index) in order.logs" :key="index" class="van-step-item">
          <h5>{{ item.time_remark }}</h5>
          <p>{{ item.create_time_text }}</p>
        </van-step>
      </van-steps>

    </div>

    <van-card
        v-for="(item_goods,ii) in order.goods"
        :key="ii"
        class="card"
        :num="item_goods.goods_num"
        :price="item_goods.goods_price"
        :title="item_goods.goods_name"
        :thumb="imgDomain+''+item_goods.goods_thumb_path"
    >
    </van-card>

    <div class="order-btn">
      <van-button type="danger" round block v-if="order.after_status == 20 || order.after_status == 30" class="btn" @click.stop="cancel(order.id)"> 取消 </van-button>
      <van-button type="primary" round block v-if="order.after_status == 20" class="btn" @click.stop="modify(order.id)"> 修改 </van-button>
      <van-button type="info" round block v-if="(order.after_status == 10 || order.after_status == 11) && order.order.able_after_sales == 1" class="btn" @click.stop="resubmit(order.id)"> 重新提交 </van-button>
      <van-button type="warning" round block v-if="order.after_status == 30" class="btn" @click.stop="ship(order.id)"> 我已寄出，填写单号 </van-button>
    </div>
  </div>
</template>

<script>
    import { cancel, get_order_after_detail } from "../../api.js";
    import { post } from "../../request.js";
    import Fontnavbar from "../../components/Navbar.vue";
    import {
        Loading,
        Toast,
        Panel,
        NavBar,
        Divider,
        Icon,
        Button,
        Tag,
        Tab,
        Tabs,
        Card,Step, Steps,
        PullRefresh, Image,ImagePreview,
        Col, Dialog, Row
    } from "vant";

    export default {
        components: {
            [Loading.name]: Loading,
            [PullRefresh.name]: PullRefresh,
            [Toast.name]: Toast,
            [Panel.name]: Panel,
            [NavBar.name]: NavBar,
            [Divider.name]: Divider,
            [Icon.name]: Icon,
            [Tag.name]: Tag,
            [Button.name]: Button,
            [Card.name]: Card,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Col.name]: Col,
            [Row.name]: Row,
            [Image.name]: Image,
            [Step.name]: Step,
            [Steps.name]: Steps,
            [ImagePreview.Component.name]: ImagePreview.Component,
            Fontnavbar
        },

        data() {
            return {
                imgDomain: process.env.VUE_APP_IMG_URL,
                order: [],
                backserve:'',
                after_status:0,
                active:0
            };
        },
        mounted() {
            const that = this;
            that.after_status = that.$route.query.after_status;
            //获取订单号
            if (that.$route.query.id) {
                var id = that.$route.query.id;
            } else {
                Toast("无订单号");
                setTimeout(() => {
                    this.$router.push({ path: "/" });
                }, 1000);
                return false;
            }
            var loading = Toast.loading({
                message: "加载中...",
                forbidClick: true,
                loadingType: "spinner",
                duration: 0
            });
            post(get_order_after_detail, { id: id }).then(res => {
                loading.clear();
                if (res.code == 200) {
                    that.order = res.data;
                    that.active = res.data.logs.length-1
                } else if (res.code == 201) {
                    this.$router.push({ path: "/user/login" });
                    return false;
                } else {
                    Toast("网络错误");
                }
            });
        },
        methods: {
            goPage(path) {
                this.$router.push({ path: path });
            },
            //取消订单
            cancel(id) {
                post(cancel, { id: id }).then((res) => {
                    if (res.code == 200) {
                        Dialog({ message: "取消成功" }).then(() => {
                            this.$router.go(0);
                        });
                    } else {
                        Dialog({ message: res.msg }).then(() => {
                            this.$router.go(0);
                        });
                    }
                });
            },
            //修改
            modify(id) {
                this.$router.push({
                    path: '/service/modify',
                    query:{
                        id:id
                    }
                });
            },
            //重新提交
            resubmit(id) {
                this.$router.push({
                    path: '/service/resubmit',
                    query:{
                        id:id
                    }
                });
            },
            //发货
            ship(id){
                this.$router.push({
                    path: '/service/ship',
                    query:{
                        id:id
                    }
                });
            },
            // 浏览图片
            browsePictures(index){
                let path = [];
                let that = this;
                this.order.images_arr.forEach(function (v) {
                    path.push(that.imgDomain + v)
                })
                ImagePreview({
                    images: path,
                    startPosition: index,
                    closeable: true,
                });
            }
        }
    };
</script>

<style lang="less" scoped>
  .order-btn {
    margin: 10px 20px;
    .btn{
      margin-bottom: 10px;
    }
  }
  .pan {
    width: 100%;
    background-color: #fff;
    padding-top: 10px;
    margin-bottom: 10px;
  }
  .pan:after {
    clear: both;
  }
  .pan-left {
    float: left;
    width: 18%;
  }
  .pan-left-div {
    width: 100%;
    text-align: right;
    font-size: 12px;
    color: #888;
    height: 18px;
    line-height: 18px;
  }

  .pan-right-div {
    width: 100%;
    text-align: left;
    font-size: 12px;
    color: #111;
    height: 18px;
    line-height: 18px;
  }
  .pan-right {
    float: left;
    width: 80%;
  }
  .card {
    background-color: #fff;
  }
  .order_list--total {
    text-align: right;
    padding: 10px;
    background-color: #fff;
    border: 1px solid #fafafa;
  }
  .label_tar{
    font-size: 10px;
    line-height: 20px;
    margin: 5px auto;
    border-bottom: 1px solid #eee;
  }
  .order_images{
    margin: 1px;
  }
  .van-step-item{
    h5,p{
      margin:0;padding:0
    }
  }
</style>
